import { Loading } from '@affine/component';
import { useI18n } from '@affine/i18n';
import { useLiveData, useService } from '@toeverything/infra';
import clsx from 'clsx';
import { useMemo } from 'react';

import { AccessibleFolderCacheStore } from '../stores/accessible-folder-cache';
import * as styles from './folder-children-loading.css';

/**
 * Loading row inside an open Folder while its first child window is read.
 * Renders nothing once the contents are loaded or the read has settled.
 */
export function FolderChildrenLoading({
  className,
  folderId,
}: {
  className?: string;
  folderId: string;
}) {
  const t = useI18n();
  const accessibleFolderCache = useService(AccessibleFolderCacheStore);
  const loading = useLiveData(
    useMemo(
      () =>
        accessibleFolderCache.initialChildrenLoadingFolderIds$.map(ids =>
          ids.has(folderId)
        ),
      [accessibleFolderCache, folderId]
    )
  );
  if (!loading) return null;
  return (
    <div
      className={clsx(styles.row, className)}
      role="status"
      aria-label={t['com.streamlain.loading']()}
      data-testid="folder-children-loading"
    >
      <Loading size={14} />
    </div>
  );
}
